import React, { useState } from "react";
import OfferLetterModal from "../components/OfferLetterModal";
import { Eye } from "lucide-react";

export default function OfferLetterPage() {
  const [open, setOpen] = useState(false);

  const [form, setForm] = useState({
    refNo: "",
    date: "",
    name: "",
    address: "",
    position: "",
    location: "",
    joiningDate: "",
    ctc: "",
    hrName: "",
    hrDesignation: "",

    basic: "",
    hra: "",
    bonus: "",
    specialAllowance: "",
    gross: "",
    employeePF: "",
    employeeESI: "",
    pt: "",
    totalDeductions: "",
    netPay: "",
    employerPF: "",
    employerESIC: "",
    subTotal: "",
    basicAnnual: "",
    basicMonthly: "",
    hraAnnual: "",
    hraMonthly: "",
    bonusAnnual: "",
    bonusMonthly: "",
    specialAllowanceAnnual: "",
    specialAllowanceMonthly: "",
    grossAnnual: "",
    grossMonthly: "",
    employeePFAnnual: "",
    employeePFMonthly: "",
    employeeESIAnnual: "",
    employeeESIMonthly: "",
    ptAnnual: "",
    ptMonthly: "",
    totalDeductionsAnnual: "",
    totalDeductionsMonthly: "",
    netPayAnnual: "",
    netPayMonthly: "",
    employerPFAnnual: "",
    employerPFMonthly: "",
    employerESICAnnual: "",
    employerESICMonthly: "",
    subTotalAnnual: "",
    subTotalMonthly: "",
    ctcAnnual: "",
    ctcMonthly: "",
  });

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  return (
    <div className="min-h-screen bg-gray-100 p-4">
      <div className=" mx-auto">
        {/* Title */}
        <h1 className="text-3xl font-semibold mb-6">Offer Letter Generator</h1>

        {/* Form Card */}
        <div className="bg-white rounded-xl shadow-md p-8">
          <div className="grid grid-cols-2 gap-6">
            {/* Ref No */}
            <div>
              <label className="block text-sm font-medium mb-1">
                Reference Number *
              </label>
              <input
                name="refNo"
                onChange={handleChange}
                className="w-full border rounded-md px-3 py-2 focus:ring-2 focus:ring-blue-500 outline-none"
              />
            </div>

            {/* Date */}
            <div>
              <label className="block text-sm font-medium mb-1">
                Offer Date *
              </label>
              <input
                type="date"
                name="date"
                onChange={handleChange}
                className="w-full border rounded-md px-3 py-2 focus:ring-2 focus:ring-blue-500 outline-none"
              />
            </div>

            {/* Employee Name */}
            <div>
              <label className="block text-sm font-medium mb-1">
                Employee Name *
              </label>
              <input
                name="name"
                onChange={handleChange}
                className="w-full border rounded-md px-3 py-2 focus:ring-2 focus:ring-blue-500 outline-none"
              />
            </div>

            {/* Position */}
            <div>
              <label className="block text-sm font-medium mb-1">
                Position *
              </label>
              <input
                name="position"
                onChange={handleChange}
                className="w-full border rounded-md px-3 py-2 focus:ring-2 focus:ring-blue-500 outline-none"
              />
            </div>

            {/* Office Location */}
            <div>
              <label className="block text-sm font-medium mb-1">
                Office Location *
              </label>
              <input
                name="location"
                onChange={handleChange}
                className="w-full border rounded-md px-3 py-2 focus:ring-2 focus:ring-blue-500 outline-none"
              />
            </div>

            {/* Joining Date */}
            <div>
              <label className="block text-sm font-medium mb-1">
                Joining Date *
              </label>
              <input
                type="date"
                name="joiningDate"
                onChange={handleChange}
                className="w-full border rounded-md px-3 py-2 focus:ring-2 focus:ring-blue-500 outline-none"
              />
            </div>

            {/* CTC */}
            <div>
              <label className="block text-sm font-medium mb-1">
                Annual CTC (₹)
              </label>
              <input
                name="ctc"
                onChange={handleChange}
                className="w-full border rounded-md px-3 py-2 focus:ring-2 focus:ring-blue-500 outline-none"
              />
            </div>
            <div className="col-span-2 mt-6">
              <h2 className="text-lg font-semibold mb-4">
                Appendix 1 : Salary Breakup
              </h2>

              <table className="w-full border border-black text-sm border-collapse">
                <thead>
                  <tr className="bg-gray-200 font-semibold">
                    <th className="border border-black p-2 text-left">
                      Components
                    </th>
                    <th className="border border-black p-2 text-right">
                      Per Annum
                    </th>
                    <th className="border border-black p-2 text-right">
                      Per Month
                    </th>
                  </tr>
                </thead>

                <tbody>
                  {/* Basic */}
                  <tr>
                    <td className="border border-black p-2">Basic</td>
                    <td className="border border-black p-2">
                      <input
                        name="basicAnnual"
                        onChange={handleChange}
                        className="w-full outline-none text-right"
                      />
                    </td>
                    <td className="border border-black p-2">
                      <input
                        name="basicMonthly"
                        onChange={handleChange}
                        className="w-full outline-none text-right"
                      />
                    </td>
                  </tr>

                  {/* HRA */}
                  <tr>
                    <td className="border border-black p-2">HRA</td>
                    <td className="border border-black p-2">
                      <input
                        name="hraAnnual"
                        onChange={handleChange}
                        className="w-full outline-none text-right"
                      />
                    </td>
                    <td className="border border-black p-2">
                      <input
                        name="hraMonthly"
                        onChange={handleChange}
                        className="w-full outline-none text-right"
                      />
                    </td>
                  </tr>

                  {/* Bonus */}
                  <tr>
                    <td className="border border-black p-2">Bonus</td>
                    <td className="border border-black p-2">
                      <input
                        name="bonusAnnual"
                        onChange={handleChange}
                        className="w-full outline-none text-right"
                      />
                    </td>
                    <td className="border border-black p-2">
                      <input
                        name="bonusMonthly"
                        onChange={handleChange}
                        className="w-full outline-none text-right"
                      />
                    </td>
                  </tr>

                  {/* Special Allowance */}
                  <tr>
                    <td className="border border-black p-2">
                      Special Allowance
                    </td>
                    <td className="border border-black p-2">
                      <input
                        name="specialAllowanceAnnual"
                        onChange={handleChange}
                        className="w-full outline-none text-right"
                      />
                    </td>
                    <td className="border border-black p-2">
                      <input
                        name="specialAllowanceMonthly"
                        onChange={handleChange}
                        className="w-full outline-none text-right"
                      />
                    </td>
                  </tr>

                  {/* Gross */}
                  <tr className="font-semibold">
                    <td className="border border-black p-2">Gross</td>
                    <td className="border border-black p-2">
                      <input
                        name="grossAnnual"
                        onChange={handleChange}
                        className="w-full outline-none text-right"
                      />
                    </td>
                    <td className="border border-black p-2">
                      <input
                        name="grossMonthly"
                        onChange={handleChange}
                        className="w-full outline-none text-right"
                      />
                    </td>
                  </tr>

                  {/* Deductions Header */}
                  <tr className="bg-gray-200 font-semibold">
                    <td className="border border-black p-2" colSpan="3">
                      Deductions
                    </td>
                  </tr>

                  {/* Employee PF */}
                  <tr>
                    <td className="border border-black p-2">Employee PF</td>
                    <td className="border border-black p-2">
                      <input
                        name="employeePFAnnual"
                        onChange={handleChange}
                        className="w-full outline-none text-right"
                      />
                    </td>
                    <td className="border border-black p-2">
                      <input
                        name="employeePFMonthly"
                        onChange={handleChange}
                        className="w-full outline-none text-right"
                      />
                    </td>
                  </tr>

                  {/* Employee ESI */}
                  <tr>
                    <td className="border border-black p-2">Employee ESI</td>
                    <td className="border border-black p-2">
                      <input
                        name="employeeESIAnnual"
                        onChange={handleChange}
                        className="w-full outline-none text-right"
                      />
                    </td>
                    <td className="border border-black p-2">
                      <input
                        name="employeeESIMonthly"
                        onChange={handleChange}
                        className="w-full outline-none text-right"
                      />
                    </td>
                  </tr>

                  {/* PT */}
                  <tr>
                    <td className="border border-black p-2">PT</td>
                    <td className="border border-black p-2">
                      <input
                        name="ptAnnual"
                        onChange={handleChange}
                        className="w-full outline-none text-right"
                      />
                    </td>
                    <td className="border border-black p-2">
                      <input
                        name="ptMonthly"
                        onChange={handleChange}
                        className="w-full outline-none text-right"
                      />
                    </td>
                  </tr>

                  {/* Total Deductions */}
                  <tr className="font-semibold">
                    <td className="border border-black p-2">
                      Total Deductions
                    </td>
                    <td className="border border-black p-2">
                      <input
                        name="totalDeductionsAnnual"
                        onChange={handleChange}
                        className="w-full outline-none text-right"
                      />
                    </td>
                    <td className="border border-black p-2">
                      <input
                        name="totalDeductionsMonthly"
                        onChange={handleChange}
                        className="w-full outline-none text-right"
                      />
                    </td>
                  </tr>

                  {/* Net Pay */}
                  <tr>
                    <td className="border border-black p-2">
                      Net Pay Before Tax
                    </td>
                    <td className="border border-black p-2">
                      <input
                        name="netPayAnnual"
                        onChange={handleChange}
                        className="w-full outline-none text-right"
                      />
                    </td>
                    <td className="border border-black p-2">
                      <input
                        name="netPayMonthly"
                        onChange={handleChange}
                        className="w-full outline-none text-right"
                      />
                    </td>
                  </tr>

                  {/* Company Contribution Header */}
                  <tr className="bg-gray-200 font-semibold">
                    <td className="border border-black p-2" colSpan="3">
                      Company Contribution
                    </td>
                  </tr>

                  {/* Employer PF */}
                  <tr>
                    <td className="border border-black p-2">Employer PF</td>
                    <td className="border border-black p-2">
                      <input
                        name="employerPFAnnual"
                        onChange={handleChange}
                        className="w-full outline-none text-right"
                      />
                    </td>
                    <td className="border border-black p-2">
                      <input
                        name="employerPFMonthly"
                        onChange={handleChange}
                        className="w-full outline-none text-right"
                      />
                    </td>
                  </tr>

                  {/* Employer ESIC */}
                  <tr>
                    <td className="border border-black p-2">Employer ESIC</td>
                    <td className="border border-black p-2">
                      <input
                        name="employerESICAnnual"
                        onChange={handleChange}
                        className="w-full outline-none text-right"
                      />
                    </td>
                    <td className="border border-black p-2">
                      <input
                        name="employerESICMonthly"
                        onChange={handleChange}
                        className="w-full outline-none text-right"
                      />
                    </td>
                  </tr>

                  {/* Sub Total */}
                  <tr className="font-semibold">
                    <td className="border border-black p-2">Sub Total</td>
                    <td className="border border-black p-2">
                      <input
                        name="subTotalAnnual"
                        onChange={handleChange}
                        className="w-full outline-none text-right"
                      />
                    </td>
                    <td className="border border-black p-2">
                      <input
                        name="subTotalMonthly"
                        onChange={handleChange}
                        className="w-full outline-none text-right"
                      />
                    </td>
                  </tr>

                  {/* CTC */}
                  <tr className="font-semibold">
                    <td className="border border-black p-2">CTC</td>
                    <td className="border border-black p-2">
                      <input
                        name="ctcAnnual"
                        onChange={handleChange}
                        className="w-full outline-none text-right"
                      />
                    </td>
                    <td className="border border-black p-2">
                      <input
                        name="ctcMonthly"
                        onChange={handleChange}
                        className="w-full outline-none text-right"
                      />
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            {/* HR Name */}
            <div>
              <label className="block text-sm font-medium mb-1">HR Name</label>
              <input
                name="hrName"
                onChange={handleChange}
                className="w-full border rounded-md px-3 py-2 focus:ring-2 focus:ring-blue-500 outline-none"
              />
            </div>

            {/* HR Designation */}
            <div className="col-span-2">
              <label className="block text-sm font-medium mb-1">
                HR Designation
              </label>
              <input
                name="hrDesignation"
                onChange={handleChange}
                className="w-full border rounded-md px-3 py-2 focus:ring-2 focus:ring-blue-500 outline-none"
              />
            </div>
          </div>

          {/* Address */}
          <div className="mt-6">
            <label className="block text-sm font-medium mb-1">
              Employee Address *
            </label>
            <textarea
              name="address"
              rows="3"
              onChange={handleChange}
              className="w-full border rounded-md px-3 py-2 focus:ring-2 focus:ring-blue-500 outline-none"
            />
          </div>

          {/* Button */}
          <div className="p-6 text-right flex justify-end">
            <button
              onClick={() => setOpen(true)}
              className="bg-sky-600 text-white px-6 py-2 rounded flex justify-center items-center gap-2"
            >
              Preview
              <Eye size={20} color="white" />
            </button>
          </div>
        </div>
      </div>

      {open && <OfferLetterModal data={form} onClose={() => setOpen(false)} />}
    </div>
  );
}
